const BlockchainLogo = ({ imgData }) => {
  return (
    <div className="landing__blockchain-img">
      <img
        src={require(`../../image/newLanding/${imgData.blockchainImg}`)}
        alt="World's No.1 Blockchain Development Company"
        loading="lazy"
      />
    </div>
  );
};

export default BlockchainLogo;
